<template>
  <div class="flex flex-col p-4">
    <form-item label="Search Album Name">
      <Input
        v-model="filterAlbum"
        placeholder="Search Album name"
      />
    </form-item>
    <form-item label="Search Artist Name">
      <Input
        v-model="filterArtist"
        placeholder="Search Artist Name"
      />
    </form-item>
    <form-item label="Categories">
      <select
        class="block border border-grey-light w-full p-3 rounded mb-4"
        name="genre"
        v-model="filter.genre_id"
      >
        <option :value="null"  >All Categories</option>
        <option
          v-for="(item, key) in listGenre"
          :key="key"
          :value="item.id"
          :v-text="item.name"
        >
          {{ item.name }}
        </option>
      </select>
    </form-item>
    <div class="flex w-full mb-3">
      <Button type="primary" @clicked="search" label="Search" class="w-full" />
    </div>
    <data-tables-server ref="tableAlbum" :data="list" :total="total" :pagination-props="{ background: true,pageSizes: [6] }" @query-change="onChangeTable" >
      <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
      </el-table-column>
      <el-table-column label="Actions" align="right" min-width="100px">
        <template slot-scope="scope">
          <div class="static inline-block text-left container-action">
            <VueCustomTooltip :label="!scope.row.added?'Add':'Remove'" :position="'is-left'">
              <button v-if="!scope.row.added" @click="addAlbumTo(scope.row,true)" class="p-2 rounded bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon :icon="['fa', 'plus']" /> Add
              </button>
              <button v-if="scope.row.added" @click="addAlbumTo(scope.row,false)" class="p-2 rounded bg-blue-100 text-blue-700 hover:bg-blue-700 hover:text-blue-100 border duration-200 ease-in-out
                          border-blue-600 transition focus:outline-none" >
                <font-awesome-icon  :icon="['fa', 'check']" /> Remove
              </button>
            </VueCustomTooltip>
          </div>
        </template>
      </el-table-column>
    </data-tables-server>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import helpersMixin from '../../mixins/helpers.mixins';
import { FormItem, Input } from '@/components/Layout/Form';
import Button from '@/components/Layout/Form/Button.vue';

export default {
  name: 'SearchAlbum',
  mixins: [helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    takenAlbum: {
      type: Array | [],
      default: () => [],
    },
  },
  data() {
    return {
      addAlbum: [],
      list: [],
      total: 0,
      listGenre: [],
      filterAlbum: 4,
      filterArtist: 4,
      filterStatus: 4,
      filter: {
        page: 1,
        per_page: 6,
        sortby: 'id',
        sortorder: 'desc',
        q: '',
        u: '',
        genre_id: null,
      },
      titles: [{
        prop: 'name',
        label: 'Album Name',
      }, {
        prop: 'artist',
        label: 'Artist Name',
      }, {
        prop: 'year',
        label: 'Year',
      }],
    };
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    ...mapGetters('AuthModule', ['tokenType', 'accessToken']),
    ...mapGetters('AlbumModule', [
      'listAlbum',
      'totalAlbum']),
  },
  watch: {
    toggleReset: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetState();
        }
      },
    },
    listAlbum: {
      immediate: true,
      deep: true,
      async handler(val) {
        this.list = this.listAlbum.map(a => ({ ...a, added: this.isExist(a.id) }));
        this.total = this.totalAlbum;
      },
    },
  },
  async mounted() {
    this.total = 0;
    this.list = [];
    this.listGenre = await this.requestGetGenreSong();
  },
  methods: {
    ...mapActions('PlaylistModule', ['requestGetGenreSong']),
    ...mapActions('AlbumModule', ['requestListAlbum']),
    resetState() {
      this.addAlbum = [...this.takenAlbum];
      this.list = [];
      this.total = 0;
      this.filter = {
        page: 1,
        per_page: 6,
        sortby: 'id',
        sortorder: 'desc',
        q: '',
        u: '',
        genre_id: null,
      };
      this.filterAlbum = '';
      this.filterArtist = '';
    },
    async searchAlbum() {
      // eslint-disable-next-line max-len
      await this.requestListAlbum(Object.assign(this.filter, { q: this.filterAlbum, u: this.filterArtist, status: this.filterStatus }));
    },
    async search() {
      this.filter.page = 1;
      await this.searchAlbum();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'ascending' || typeof (queryInfo.sort.order) === 'undefined' ? 'desc' : 'asc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortby = 'status_updated_at';
      sortorder = 'desc';
      this.filter = Object.assign(this.filter, { sortorder, sortby, page });
      await this.searchAlbum();
    },
    isExist(id) {
      return this.addAlbum.findIndex(song => song.id === id) !== -1;
    },
    addAlbumTo(row, status) {
      row.added = status;
      if (status) {
        const newRow = { ...row };
        this.addAlbum.push(newRow);
      } else {
        this.$emit('on-remove-album', row.id);
        const index = this.addAlbum.findIndex(song => song.id === row.id);
        this.addAlbum.splice(index, 1);
      }
    },
    submit() {
      this.$emit('on-submit-album', this.addAlbum);
    },
  },
  components: { Button, FormItem, Input }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AppSetting/SearchAlbum.vue